import React, { useEffect, useState } from "react";
import "./Navbar.css";
import { FiLogOut } from "react-icons/fi";

export default function Navbar({ onLogout }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      {/* top ribbon with marquee-like animation */}
      <div className="top-ribbon">
        <div className="ribbon-track">
          <span>🚀 L&amp;B GenAI KrishiTech — Free Industry-Led Online Training &amp; Internship • Oct–Dec 2025 • Limited seats • Apply now! 🚀</span>
          <span>🚀 L&amp;B GenAI KrishiTech — Free Industry-Led Online Training &amp; Internship • Oct–Dec 2025 • Limited seats • Apply now! 🚀</span>
        </div>
      </div>

      <nav className={`glass-nav ${scrolled ? "scrolled" : ""}`}>
        <div className="nav-inner">
          <button className="brand" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            <img src="/images/lnb.png.jpeg" alt="L&B" />
            <span>L&amp;B GenAI KrishiTech</span>
          </button>

          <div className="links">
            <button onClick={() => go("vision")}>Vision</button>
            <button onClick={() => go("about")}>Program</button>
            <button onClick={() => go("ai")}>AI in Farming</button>
            <button className="register" onClick={() => go("register")}>Register</button>
            <button className="logout" onClick={onLogout}><FiLogOut /> Logout</button>
          </div>
        </div>
      </nav>
    </>
  );
}
